// extracted by mini-css-extract-plugin
export default {"header":"Header_header__wUk1C","scrolled":"Header_scrolled__ZHgFF"};